export const euroTvScheduleModule = {
  name: 'Euro Tv Schedule',
};
